/**
 * @generated SignedSource<<52e55a8726ac79cbfb1172510894a5b6>>
 * @relayHash 77d56fc84b344cc7c86300b4ca381f19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9569496d7f33b9bf3caecfab77ff1558bac1ba1ac5b3dc5fe9834839430b61b2

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterSettingsWidgetConfigurationCustomizeAppQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
  isConsentFormEnabled: boolean;
  widgetId: string;
};
export type HelpCenterSettingsWidgetConfigurationCustomizeAppQuery$data = {
  readonly csmAi_getWidget: {
    readonly __typename: "CsmAiWidgetConfig";
    readonly " $fragmentSpreads": FragmentRefs<"brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly " $fragmentSpreads": FragmentRefs<"brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
};
export type HelpCenterSettingsWidgetConfigurationCustomizeAppQuery = {
  response: HelpCenterSettingsWidgetConfigurationCustomizeAppQuery$data;
  variables: HelpCenterSettingsWidgetConfigurationCustomizeAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isConsentFormEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "widgetId"
},
v4 = {
  "kind": "Variable",
  "name": "helpCenterAri",
  "variableName": "helpCenterAri"
},
v5 = [
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "widgetId",
    "variableName": "widgetId"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v8 = [
  (v4/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "isEnabled"
},
v11 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HelpCenterSettingsWidgetConfigurationCustomizeAppQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getWidget",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "isConsentFormEnabled",
                    "variableName": "isConsentFormEnabled"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference"
              }
            ],
            "type": "CsmAiWidgetConfig"
          }
        ]
      },
      {
        "args": (v7/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v8/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference"
                  }
                ],
                "type": "HelpCenter"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "HelpCenterSettingsWidgetConfigurationCustomizeAppQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getWidget",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*: any*/),
              {
                "kind": "ScalarField",
                "name": "allowedDomains"
              },
              {
                "kind": "ScalarField",
                "name": "isAnonymousAccessEnabled"
              },
              (v10/*: any*/),
              {
                "kind": "ScalarField",
                "name": "type"
              },
              {
                "kind": "ScalarField",
                "name": "position"
              },
              {
                "concreteType": "CsmAiWidgetBrandingTheme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "colorVibeVariant"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "radius"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "space"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "chatColor"
                  },
                  {
                    "concreteType": "CsmAiWidgetBrandingAttribution",
                    "kind": "LinkedField",
                    "name": "attribution",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "text"
                      },
                      (v11/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "welcomeMessage"
                  }
                ]
              },
              {
                "condition": "isConsentFormEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "CsmAiWidgetConsentForm",
                    "kind": "LinkedField",
                    "name": "consentForm",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "policy"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "acceptLabel"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "declineLabel"
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "CsmAiWidgetConfig"
          }
        ]
      },
      {
        "args": (v7/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v8/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fileId"
                          },
                          (v11/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9569496d7f33b9bf3caecfab77ff1558bac1ba1ac5b3dc5fe9834839430b61b2",
    "metadata": {},
    "name": "HelpCenterSettingsWidgetConfigurationCustomizeAppQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1e0eaf37f6876d310180100049dc0022";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
